<div class="add-card-dialog">
  <app-dialog-header title="Adicionar novo cartão" [disabled]="saving" />

  <mat-dialog-content class="add-card-dialog__content">
    <app-credit-card
      [cardData]="creditCardData"
      [isFlipped]="isCardFlipped"
      [readonly]="false"
      (cardDataChange)="onCreditCardDataChange($event)"
      (flipCard)="onCardFlip()"
      (focusCvv)="onCvvFocus()">
    </app-credit-card>
  </mat-dialog-content>

  <mat-dialog-actions class="add-card-dialog__actions">
    <app-button type="button" styleType="outlined" [disabled]="saving" (btnClick)="handleCancelClick()">
      Cancelar
    </app-button>
    <app-button type="button" [loading]="saving" [disabled]="saving" (btnClick)="handleSaveClick()">
      Salvar cartão
    </app-button>
  </mat-dialog-actions>
</div>
